// =============================================================================
//  Copyright : 2022 semantics GmbH
//  Date      : $Date: 2026-01-24 02:54:28 +0100 (Sat, 24 Jan 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 159989 $
//  Purpose   : vlm support
// =============================================================================
export const parts = true;
import * as views from './views';
export { views };
import * as reducers from './reducers';
export { reducers };
